import { isNil } from 'ramda';

import { FloatNumber } from './NumberTypes/FloatNumber';

export class Voltage {
  readonly unit: 'V' | 'kV' = 'V' as const;
  private value: number;
  constructor(loading: number, unit: 'V' | 'kV' = 'V') {
    this.value = loading;
    this.unit = unit;
  }

  toKilo() {
    if (this.unit !== 'kV') {
      if (isNil(this.value)) return new Voltage(this.value, 'kV');

      return new Voltage(this.value / 1000, 'kV');
    }
    return this;
  }

  toString() {
    if (!isFinite(this.value)) return 'N/A';
    return `${FloatNumber.fromNumber(this.value).round(2)} ${this.unit}`;
  }
}
